import Flex from 'frontend/commons/Flex';
import { FALLBACK_IMAGE } from 'frontend/constants';
import { usePackageCard } from 'frontend/contexts/PackageCardContext';
import getFinalPrice from 'frontend/utils/get-final-price';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CardGallery from './components/CardGallery';
import DynamicContent from './components/DynamicContent';
import IncludesRow from './includesRow';
import totalNightTextSetter from 'frontend/utils/total-night-text';

const PackageCard = () => {
  const { t } = useTranslation(['layout']);
  const [showGallery, setShowGallery] = useState();
  const { packageData, displayInfo, handleDisplayInfoToggle } = usePackageCard();

  const {
    title,
    images,
    totalNights,
    packageOrigins,
    packageDestinations,
    currencyCode,
    cheapestOption,
    provider_id,
  } = packageData;

  const galleyOfImages = useMemo(
    () =>
      provider_id === 3
        ? images
        : packageDestinations?.map((dest) => dest.destinationCity.imageUrl || FALLBACK_IMAGE),
    [packageDestinations],
  );

  const handleShowGallery = () => {
    setShowGallery((state) => !state);
  };

  return (
    <Flex vertical className="package-card">
      <Flex className="package-card__data">
        <img
          className="package-card__data__img"
          onClick={handleShowGallery}
          src={provider_id === 1 ? packageDestinations?.[0]?.destinationCity?.imageUrl : images[0]}
          alt="Package Destination"
        />
        <Flex vertical className="package-card__data__wrapper">
          <Flex vertical className="package-card__data__wrapper__info">
            <h3 className="package-card__data__wrapper__info__title">{title}</h3>
            <div className="package-card__data__wrapper__info__details">
              <p>
                <strong>{t('packages.details.departure')}:</strong>
                <span>{packageOrigins[0].originExporta.nombreCiudad}</span>
              </p>
              <p>
                <strong>{t('searcher.destination')}:</strong>
                <span>{packageDestinations[0].destinationCity.nombreCiudad}</span>
              </p>
              <p>
                <strong>{totalNightTextSetter(totalNights)}</strong>
              </p>
              <p className="package-card__data__wrapper__info__details__price">
                <strong>{t('common.since')}:</strong>
                <span>
                  {getFinalPrice({
                    currencyCode,
                    total: cheapestOption.totalManager.total,
                  })}
                </span>
              </p>
            </div>
          </Flex>
          <Flex className="package-card__data__wrapper__footer">
            <IncludesRow />
            <Flex className="package-card__data__wrapper__footer__buttons">
              <button
                className={displayInfo ? 'active' : undefined}
                onClick={() => {
                  handleDisplayInfoToggle();
                }}
              >
                {t('common.more_details')}
              </button>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      <DynamicContent />
      <CardGallery
        showGallery={showGallery}
        handleShowGallery={handleShowGallery}
        packageDestinations={packageDestinations}
        images={galleyOfImages}
      />
    </Flex>
  );
};

export default PackageCard;
